'use client';

import * as React from 'react';
import { cn } from '@shared/utils';

interface LogoProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  className?: string;
}

export function Logo({ size = 32, className, ...props }: LogoProps) {
  // Constants for quadrant calculations - increased ratios to reduce whitespace
  const largeRatio = 0.85; // Increased from 275/540 ≈ 0.51
  const smallRatio = 0.7; // Increased from 234/540 ≈ 0.43
  const defaultRadius = size / 2;
  const stroke = 0.5 * defaultRadius * (largeRatio);

  // Helper function to generate quadrant paths
  const getPath = (type: 'radiant' | 'rogue' | 'valiant' | 'true'): string => {
    const s = type === 'radiant' || type === 'true' ? defaultRadius * largeRatio : defaultRadius * smallRatio;
    switch (type) {
      case 'radiant':
        return `M 0 0 L -${s} 0 A ${s} ${s} 0 0 1 0 -${s} L 0 0`;
      case 'rogue':
        return `M 0 0 L 0 -${s} A ${s} ${s} 0 0 1 ${s} 0 L 0 0`;
      case 'valiant':
        return `M 0 0 L 0 ${s} A ${s} ${s} 0 0 1 -${s} 0 L 0 0`;
      case 'true':
        return `M 0 0 L ${s} 0 A ${s} ${s} 0 0 1 0 ${s} L 0 0`;
    }
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
      className={cn("", className)}
      {...props}
    >
      <g transform={`translate(${defaultRadius} ${defaultRadius})`}>
        {/* Quadrants */}
        <path
          d={getPath('radiant')}
          className="fill-radiant"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d={getPath('rogue')}
          className="fill-rogue"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d={getPath('valiant')}
          className="fill-valiant"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d={getPath('true')}
          className="fill-true"
          vectorEffect="non-scaling-stroke"
        />
      </g>
    </svg>
  );
}
